import { css } from "lit";

export const repeatRuleFormStyles = css`
    :host {
        display: block;
        background-color: white;
        padding: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin: 0;
        flex: 1;
    }

    .form__month-day-select {
        width: 90px;
    }

    .divider {
        border: 1px solid black;
        border-bottom: none;
        margin: 0;
    }

    .repeat-option-container {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .repeat-option-input {
        width: 70px;
    }

    .weekdays-container {
        display: flex;
        justify-content: space-between;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 10px;
        margin-top: auto;
    }
`;
